// extracted by css-extract-rspack-plugin
export default {"AlertModalsBorder":"E20lR","AlertModalsTextWidth":"HPabs","AlertModalsFooter":"dyhLF"};